import styled, {css} from 'styled-components'

export const StyledReadOnlyView = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['600']};
        width: 100%;
        height: 100%;
        background-color: ${palette.neutral['100']};
        border-radius: 6px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        white-space: pre-wrap;
        max-height: 386px;
        overflow: auto;

        &::selection {
            background-color: ${palette.neutral['300']};
            color: ${palette.neutral['950']};
        }
    `
)
